import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1d9d1c4b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  for: "props.idDrop"
}
const _hoisted_2 = {
  key: 0,
  id: "props.idDrop"
}
const _hoisted_3 = { style: {"width":"100%"} }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Select option ")

import { computed, onMounted, PropType } from 'vue';
import { OptionDrop } from '../../types/types';

// eslint-disable-next-line

export default /*#__PURE__*/_defineComponent({
  __name: 'BaseSddsDropdown',
  props: {
  idDrop: {
    type: String,
    default: null,
    required: true,
  },
  selection: {
    type: String,
    default: null,
  },
  options: {
    type: Array as PropType<Array<OptionDrop>>,
    default: () => [],
  },
  size: {
    type: String,
    default: 'Large',
  },
  labelDescription: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
  includeDeselect: {
    type: Boolean,
    default: false,
  }
},
  emits: ['update:selection'],
  setup(__props, { emit }) {

const props = __props



// eslint-disable-next-line


const selectedValue = computed(() => (props.selection));

const isThereALabel = computed(() => (props.labelDescription.length > 0));

const isShowMessageRequired = computed(() => (!!(props.required && (selectedValue.value ?? '*') === '*')));

const getMessageHelper = computed(() => (props.required && (selectedValue.value ?? '*') === '*' ? 'Field Required' : null));

function handleSelectOption(event: Event) {
  // console.log('handleSelectOption: ', event);
  emit('update:selection', { keyDropdown: props.idDrop, value: (event.target as HTMLInputElement).value });
}

onMounted(() => {
  if (props.idDrop) {
    // console.log('props.idDrop: ', props.idDrop);
    const dropdownElement = document.getElementById(props.idDrop);
    dropdownElement?.addEventListener('selectOption', handleSelectOption);
  }
});

return (_ctx: any,_cache: any) => {
  const _component_sdds_dropdown_option = _resolveComponent("sdds-dropdown-option")!
  const _component_sdds_dropdown = _resolveComponent("sdds-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(isThereALabel))
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createTextVNode(_toDisplayString(__props.labelDescription) + " ", 1),
          false
            ? (_openBlock(), _createElementBlock("input", _hoisted_2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_sdds_dropdown, {
        id: props.idDrop,
        placeholder: "Select option",
        label: "Label text",
        size: __props.size,
        "default-option": _unref(selectedValue),
        "selected-option": _unref(selectedValue),
        state: _unref(isShowMessageRequired) ? 'error' : '',
        helper: _unref(getMessageHelper)
      }, {
        default: _withCtx(() => [
          (__props.includeDeselect)
            ? (_openBlock(), _createBlock(_component_sdds_dropdown_option, {
                key: 0,
                selected: "true",
                value: null
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (option, index) => {
            return (_openBlock(), _createBlock(_component_sdds_dropdown_option, {
              key: index,
              value: option.key
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(option.value), 1)
              ]),
              _: 2
            }, 1032, ["value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["id", "size", "default-option", "selected-option", "state", "helper"])
    ])
  ], 64))
}
}

})